﻿import { Auth } from "./auth.js";
import { syncPurchaseBadgesToOrders } from "./purchase_plans.js";
import { ensureMappingsLoaded, applyProductMappings, renderOrderCard } from "./orders_render.js";
import { fetchOrdersFromServer, syncCleanupOnServer, saveOrderToServer } from "./orders_api.js";

/**
 * Efast Workbench - 订单数据层 (CRUD + 持久化)
 * 从 sales_logic.js 拆分
 */

window.allOrders = [];

const defaultMockOrders = [
    {
        id: "180493820491823",
        amount: "USD $15,000.00",
        salesperson: "Samson",
        buyerCountry: "Germany",
        buyerName: "Dieter Weber",
        buyerLevel: "High",
        buyerAddress: "Musterstraße 123, 20095 Hamburg, Germany",
        buyerPhone: "+49 40 1234567",
        daysLeft: -2,
        shipDate: "2026-06-05",
        status: "待卖家发货",
        products: [
            {
                title: "Premium ZF71 Car Magnetic Phone Holder (Laser Logo Customization)",
                link: "https://www.alibaba.com/product-detail/Premium-ZF71-Car-Magnetic-Phone-Holder_160012345678.html",
                specs: "硅胶垫，激光雕刻Logo，氧化黑色铝合金，强力N52磁铁",
                qty: "2000"
            }
        ]
    },
    {
        id: "180493820491824",
        amount: "USD $8,550.00",
        salesperson: "Samson",
        buyerCountry: "Netherlands",
        buyerName: "Lars Janssen",
        buyerLevel: "",
        buyerAddress: "Hoofdstraat 456, 1012 AB Amsterdam, Netherlands",
        buyerPhone: "+31 20 9876543",
        daysLeft: 5,
        shipDate: "2026-06-12",
        status: "待卖家发货",
        products: [
            {
                title: "Upgraded ZF72 Venture Vent Car Mount with Advanced N52 Neodymium Magnets",
                link: "https://www.alibaba.com/product-detail/Upgraded-ZF72-Venture-Vent-Car-Mount_160087654321.html",
                specs: "锌合金钢钩，CE/FCC/RoHS认证版",
                qty: "1000"
            }
        ]
    }
];

async function loadStoredSalesData() {
    console.log("[Efast Workbench] 正在从服务器加载订单数据...");

    try {
        const serverOrders = await fetchOrdersFromServer();
        if (Array.isArray(serverOrders) && serverOrders.length > 0) {
            allOrders = serverOrders.filter(function(o) { return !o.source || o.source === 'overview' || o.source === 'alibaba'; });
            console.log('[Efast Data] 成功加载服务器订单，数量:', allOrders.length);
        } else {
            allOrders = window.__efastSyncInProgress ? [] : defaultMockOrders;
        }
    } catch (e) {
        console.error('加载订单失败:', e);
        allOrders = defaultMockOrders;
    }

    await ensureMappingsLoaded();
    for (var mi = 0; mi < allOrders.length; mi++) {
        await applyProductMappings(allOrders[mi]);
    }

    allOrders.sort((a, b) => {
        if (a.isSelfOrder && !b.isSelfOrder) return -1;
        if (!a.isSelfOrder && b.isSelfOrder) return 1;
        
        const calcDays = (o) => o.shipDate ? Math.ceil((new Date(o.shipDate) - new Date()) / 86400000) : (o.daysLeft != null ? o.daysLeft : 999);
        return calcDays(a) - calcDays(b);
    });

    const selfOrders = allOrders.filter(o => o.isSelfOrder);
    const alibabaOrders = allOrders.filter(o => !o.isSelfOrder);
    console.log('[Efast Data] 自建订单:', selfOrders.length, '国际站订单:', alibabaOrders.length);

    // 动态兜底：如果容器不存在，在 #view-order-overview 中创建双栏布局
    ensureOrderOverviewLayout();

    const todoList = document.getElementById("workbench-todo-list");
    if (todoList) {
        todoList.innerHTML = '';
        alibabaOrders.forEach(function(ord) {
            try { renderOrderCard(ord, false); } 
            catch (e) { console.error('渲染订单失败 id=' + ord.id, e); }
        });
    } else {
        console.error('[Efast Data] ❌ workbench-todo-list 不存在，无法渲染国际站订单');
    }

    const selfList = document.getElementById("self-order-list");
    if (selfList) {
        selfList.innerHTML = '';
        selfOrders.forEach(function(ord) {
            try { renderOrderCard(ord, false, selfList); } 
            catch (e) { console.error('渲染自建订单失败 id=' + ord.id, e); }
        });
    } else {
        console.error('[Efast Data] ❌ self-order-list 不存在，无法渲染自建订单');
    }
    
    setTimeout(function() { if (typeof syncPurchaseBadgesToOrders === 'function') syncPurchaseBadgesToOrders(); }, 1000);
}

function ensureOrderOverviewLayout() {
    var overview = document.getElementById('view-order-overview');
    if (!overview) { console.warn('[Efast Data] view-order-overview 不存在'); return; }

    var todoList = document.getElementById('workbench-todo-list');
    var selfList = document.getElementById('self-order-list');
    var consoleLog = document.getElementById('sync-console-log');

    if (!todoList || !selfList || !consoleLog) {
        console.warn('[Efast Data] ⚠️ 容器缺失（todoList=' + !!todoList + ' selfList=' + !!selfList + ' consoleLog=' + !!consoleLog + '），动态重建布局');
        overview.innerHTML = '<section><div class="dashboard-grid">' +
            '<div class="dashboard-card order-todo-box">' +
            '<div class="card-header"><h2><i class="fa-solid fa-boxes-packing"></i> 国际站订单</h2>' +
            '<button class="btn-action btn-sm" onclick="batchImportAllToCRM()" style="margin-left:auto;background:#f59e0b;color:#fff;border:none;border-radius:6px;padding:6px 14px;cursor:pointer;font-size:0.8rem;font-weight:bold;">' +
            '<i class="fa-solid fa-cloud-upload-alt"></i> 一键导入CRM</button></div>' +
            '<div class="sync-actions-row" style="display:flex;align-items:center;gap:8px;">' +
            '<button class="btn-sync" id="btn-sync-alibaba" onclick="syncForOverview()">' +
            '<i class="fa-solid fa-cloud-arrow-down"></i> 同步国际站订单</button>' +
            '<span class="sync-tooltip" style="cursor:pointer;color:#94a3b8;font-size:1.1rem;display:inline-flex;align-items:center;" title="请业务员在Chrome中打开阿里订单待发货页面，并设置为每页显示50条订单，然后点击同步按钮。">' +
            '<i class="fa-regular fa-circle-question"></i></span></div>' +
            '<div class="console-box" id="sync-console-log">' +
            '<p class="console-line">[' + new Date().toLocaleTimeString() + '] 系统就绪 - 容器动态创建</p></div>' +
            '<ul class="todo-list" id="workbench-todo-list"></ul></div>' +
            '<div class="dashboard-card">' +
            '<div class="card-header" style="padding-top:0;">' +
            '<h2><i class="fa-solid fa-file-pen"></i> 自建订单</h2></div>' +
            '<ul class="todo-list" id="self-order-list"></ul></div>' +
            '</div></section>';
    }
}

export { loadStoredSalesData, syncCleanupOnServer, saveOrderToServer };window._reloadOrders = loadStoredSalesData;

